<template>
    <div class="table_width">
        <Table border :columns="columns" :data="dataNews" class="border" @on-selection-change="changeProdNumber"></Table>
        <div class="hand_move_wei_hu_cheng_pin">
            <!--<p>-->
                <!-- <div class="shoutian" v-bind:style="{styleA:true}"> -->
                <div v-show="shoutiandis">

              <RadioGroup v-model="changeWidth" vertical class="hand_move_wei_hu_cheng_pin_width" @on-change="changeWidthList">
                    <Radio label="last" class="radios">
                      <span>{{language.shengyu}}</span>
                      <span class="hand_move_wei_hu_last">{{lastWidth}}</span>
                      <span class="biansitxt">{{language.shengyudayu204shibixukouchu4mm}}</span>
                    </Radio>

                <Radio label="residue" class="radios" id="biansi">
                  <span>{{language.biansi}}</span>
                  <span class="hand_move_wei_hu_last"  v-show="handNoveWeiHuChengPinWidth">{{residueWidth}}</span>
                  <span class="biansitxt">{{language.biansifanweibixuzai3dao40zhijianxiaoyu3zebuketijiao}}</span>

                </Radio>
              </RadioGroup>
              <div class="position_hand_move_div">
                <span>{{language.jiaohuodi}}：</span>
                <Select v-model="shengYuArea" style="width:200px">
                    <Option v-for="item in placeofDelivery" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </div>
            </div>
            

                    <span class="hand_move_wei_hu_cheng_pin_add" @click="handMoveWeiHuChengPinAdd" v-show="xinzengshow">+</span>
              <p class="position_hand_move">
                <span class="hand_move_wei_hu_last"  v-show="!handNoveWeiHuChengPinWidth"></span>
                
                <!-- <span  v-show="handNoveWeiHuChengPinTrue" class="hand_move_wei_hu_cheng_pin_true" @click="dataNewsInformation({'dataNews':dataNews,'residueWidth':residueWidth})">确认</span> -->
                <span  v-show="handNoveWeiHuChengPinTrue" class="hand_move_wei_hu_cheng_pin_true" @click="handMoveWeiHuChengPinTrue">{{language.baocun}}</span>
                <span  v-show="!handNoveWeiHuChengPinTrue" class="hand_move_wei_hu_cheng_pin_true btn_black" @click="messageInfomation">{{language.baocun}}</span>
                
              </p>
              <!--<span class="hand_move_wei_hu_cheng_pin_width">剩余</span><input v-on:blur="lastWidthChange" type="text" v-model="lastWidth">-->
            <!--</p>-->
            <!--<p>-->
                <!--<span v-show="handNoveWeiHuChengPinWidth" class="hand_move_wei_hu_cheng_pin_width">边丝：</span>-->
                <!--<span v-show="handNoveWeiHuChengPinWidth" class="hand_move_wei_hu_cheng_pin_width_num">{{residueWidth}}</span>-->
                <!--<span class="hand_move_wei_hu_cheng_pin_add" @click="handMoveWeiHuChengPinAdd">新增</span>-->
                <!-- <span  v-show="handNoveWeiHuChengPinTrue" class="hand_move_wei_hu_cheng_pin_true" @click="dataNewsInformation({'dataNews':dataNews,'residueWidth':residueWidth})">确认</span> -->
                <!--<span  v-show="handNoveWeiHuChengPinTrue" class="hand_move_wei_hu_cheng_pin_true" @click="handMoveWeiHuChengPinTrue">确认</span>-->
                <!--<span  v-show="!handNoveWeiHuChengPinTrue" class="hand_move_wei_hu_cheng_pin_true btn_black" @click="messageInfomation">确认</span>-->
                <!--<span class="">边丝最佳范围在3-40之间，小于3则不可提交</span>-->
            <!--</p>-->
        </div>
    </div>
</template>
<style lang="scss" scoped>
    #biansi{
        margin-top:45px;
    }
    .position_hand_move_div{
      position: absolute;
      right: 0;
      top:35px;
    }
    .position_hand_move{
      position: absolute;
      right: 250px;
      bottom: -20px;
      margin-bottom: -10px;
    }
    .hand_move_wei_hu_last{
      margin-left: 20px;
      margin-right: 40px;
      width:50px;
    }
    .btn_black{
        color:white !important;
        background-color:red !important;
    }
    .expand-row{
        margin-bottom: 16px;
    }
    .table_width{
        width:811px;
        /*min-height: 200px;*/
    }

    .hand_move_wei_hu_cheng_pin{
        position: relative;
        width:100%;
        height:80px;
        /*line-height:40px;*/
        /*p{*/
            /*margin:0;*/
            /*padding:0;*/
            /*width:100%;*/
            /*height:40px;*/
            /*line-height:40px;*/
            span{
                display:inline-block;
                margin-left:10px;
            }
            input{
              width: 100px;
              height: 24px;
              line-height: 24px;
              border: 1px solid #eee;
              border-radius: 4px;
              margin-left: 20px;
              text-indent: 1em;
              margin-right: 50px;
            }
            .hand_move_wei_hu_cheng_pin_width{
                margin-left:50px;
            }
            .hand_move_wei_hu_cheng_pin_width_num{
                width:30px;
                height:30px;
                line-height:30px;
                color:#333;
            }
            .hand_move_wei_hu_cheng_pin_add{
                cursor:pointer;
                margin-left:10px;
                width:70px;
                height:30px;
                line-height:30px;
                text-align:center;
                border-radius:4px;
                background-color:skyblue;
                font-size:30px;
                color:white;
                position: absolute;
                right: -100px;
                top:-34px;
                z-index: 10;
                /*border-radius:30px;*/
                /*left: -100px;*/
                &:hover{
                    /*color:red;*/
                }
            }
            .hand_move_wei_hu_cheng_pin_true{
                cursor:pointer;
                margin-left:10px;
                width:70px;
                /*height:70px;*/
                text-align:center;
                border-radius:4px;
                line-height:30px;
                background-color:red;
                color:#fff;
                position: absolute;
                right: -350px;
                top:-200px;
                &:hover{
                    /*color:red;*/
                }
            }
        /*}*/
    }
</style>
<style>

</style>
<script>
    // import {mapGetters,mapActions} from 'vuex'
    import axios from 'axios';
    import config from 'config/apiConfig'
    import language from 'api/language'
    export default {
        data(){
            return{
                language:{},
                ifDengFenDisabled:false,
                shengYuArea:'',
                changeWidth: "residue",
                activeWidth:'',
                lastWidth:'0',
                // selectedActive:0,
                residueWidth:'0',
                handNoveWeiHuChengPinTrue:false,
                handNoveWeiHuChengPinWidth:true,
                xinzengshow:true,
                shoutiandis:true,
                indexlast:'',
                // styleB:false,
                styleA:{
                    backgroundColor:"black",
                    color:'red',
                    display:'inlineBlock'
                },
                columns: [

                    {
                        type: 'selection',
                        width: 60,
                        align: 'center',
                        // render: (h, params) => {
                        //     if(this.dataNews[params.index].prodHeight=="C"){
                        //         alert(111)
                        //     return h('selection', {
                        //             props: {
                        //                 disabled:true
                        //                 // number:true,
                        //                 // value:this.dataNews[params.index].prodWidth?this.dataNews[params.index].prodWidth:0
                        //             },
                        //             // on:{
                        //             //     'on-blur':(event) => {
                        //             //         this.addWidthDataFive(params,event.target.value)
                        //             //     }
                        //             // },
                        //         })
                        //     ;
                        // }else{

                        //     return h('selection', {
                        //             props: {
                        //                 disabled:false
                        //                 // number:true,
                        //                 // value:this.dataNews[params.index].prodWidth?this.dataNews[params.index].prodWidth:0
                        //             },
                        //             // on:{
                        //             //     'on-blur':(event) => {
                        //             //         this.addWidthDataFive(params,event.target.value)
                        //             //     }
                        //             // },
                        //         })
                        // }
                        // }
                    },
                    {
                        title: language.kuan,
                        key: 'prodWidth',
                        align: 'center',
                        width: 100,
                        render: (h, params) => {
                            return h('div',
                            [
                                h('Input', {
                                    props: {
                                        number:true,
                                        value:this.dataNews[params.index].prodWidth?this.dataNews[params.index].prodWidth:0
                                    },
                                    on:{
                                        'on-blur':(event) => {
                                            this.addWidthDataFive(params,event.target.value)
                                        }
                                    },
                                })
                            ]);
                        }
                    },
                    {
                        title: language.chang,
                        key: 'prodHeight',
                        align: 'center',
                        width: 100,
                        render: (h, params) => {
                            return h('div',

                            [
                                h('Input', {
                                    props: {
                                        number:true,
                                        value:this.dataNews[params.index].prodHeight
                                        // value:'C'
                                    },
                                    on:{
                                        'on-blur':(event) => {
                                            this.addHeightDataFive(params,event.target.value)
                                            //vm.data[params.index].value = event.target.value;
                                        }
                                    },
                                })
                            ]);
                        }
                    },
                    {
                        title: language.lilunshuliang,
                        key: 'prodNumber',
                        align: 'center',
                        width: 100,
                        render: (h, params) => {
                            let that = this;
                            that.dataNews[params.index].prodNumber = 1;
                            // if(params.row.prodHeight == 'C'){
                            //     if(that.selectDatas.indexOf(params.row.dataId) > -1){

                            //     }
                                
                            // }
                            return h('div',
                            [
                                h('Input', {
                                    attrs: {
                                        disabled:params.row.prodHeight == 'C'?true:!(that.selectDatas.indexOf(params.row.dataId) > -1),
                                        // disabled:!(that.selectDatas.indexOf(params.row.dataId) > -1),
                                        value:that.dataNews[params.index].prodNumber
                                    },
                                    on:{
                                        'on-blur':(event) => {
                                            that.addNumDataFive(params,event.target.value)
                                            //vm.data[params.index].value = event.target.value;
                                        },
                                        // 'on-change':()=>{

                                        // }
                                    },
                                })
                            ]
                            );
                        }
                    },
                    {
                        title: language.lilunzongzhongliang,
                        key: 'prodOneWeight',
                        align: 'center',
                        width: 100,
                        // render: (h, params) => {
                        //     // console.log(params)
                        //     return h('div',this.data4.processingWeight) ;
                        // }
                    },
                    {
                        title: language.jiaohuodi,
                        key: 'deliveryPlaceCode',
                        align: 'center',
                        width: 250,
                        className:'deliveryPlaceCode',
                        render: (h, params) => {
                            let that = this;
                            const options =
                                that.placeofDelivery.map(function(type){
                                    return h('Option', {
                                        props: {label: type.label == null?'':type.label,value: type.value == null?'':type.value},
                                        style:{
                                            width:'150px',
                                            overflow:'hidden',
                                        },
                                        attrs: {title: type.label}
                                    }, type.label);
                                });
                            if(params.row._index==0){
                              return h('Select', {
                                  props:{
                                      filterable:true,
                                      labelInValue:true,
                                      value: that.dataNews[params.index].deliveryPlaceCode,
                                  },
                                  style:{
                                    marginLeft:'5px',
                                    width:'80%'
                                  },
                                  on: {
                                      'on-change':(value) => {
                                          that.changeValue(value,params);
                                      }
                                  },
                              },
                              [options
                              ]
                              );
                            }else{
                              return h('div',[
                              h('Select', {
                                  props:{
                                      filterable:true,
                                      labelInValue:true,
                                      value: that.dataNews[params.index].deliveryPlaceCode,
                                  },
                                  style:{
                                    marginLeft:'5px',
                                    width:'80%'
                                  },
                                  on: {
                                      'on-change':(value) => {
                                          that.changeValue(value,params);
                                      }
                                  },
                              },
                              [options
                              ]
                              ),h('Button', {
                                props: {
                                  size: 'small'
                                },
                                style:{
                                  marginLeft:'5px',
                                  border:'none',
                                  backgroundColor:'#fff'
                                },
                                attrs:{
                                  title:'상동'
                                },
                                on:{
                                  click: ()=>{
                                    this.againDeliveryDate(params)
                                  }
                                }
                              },[
                                h('Icon', {
                                  props: {
                                    type: 'arrow-up-a'
                                  },
                                  style:{
                                    color:"#0066ff",
                                    fontSize:"30px"
                                  }
                                })
                              ])]);
                            }
                        },
                    },
                    {
                        title: language.caozuo,
                        key: 'specification',
                        align: 'center',
                        width: 100,
                        render: (h, params) => {
                            return h('div',{
                                style:{
                                    width:'21px',
                                    height:'25px',
                                    margin:'0 auto',
                                    // textAlign:'left',
                                },
                                on:{
                                    click:() => {
                                        this.removeDataFive(params)
                                        //vm.data[params.index].value = event.target.value;
                                    }
                                },
                            }, [
                                h('Icon', {
                                style:{
                                    color:'skyblue',
                                    fontSize:'25px',
                                    cursor:'pointer',
                                    // textAlign:'left',
                                },
                                props:{
                                    type:'close-circled'
                                },
                                })
                            ]);
                        }
                    },
                ],
                dataNews:[{deliveryPlaceCode:'',prodWidth:0,deliveryPlace:'',prodHeight:'C',dataId:0,prodOneWeight:'',prodNumber:''}],
                placeofDelivery:[],
                dataId:0,
                selectDatas:[],
//                data4:this.data4,
            }
        },
        watch: {
          'data4':{
            handler: function (newVal,oldVal) {
              // console.log('1111'+newVal,oldVal)
//              this.data4.processingWeight= newVal;
//              this.addWidthDataFiveNew()
            },
            deep: true
          }
        },
        // computed: {
        //     ...mapGetters({
        //         dataNewsInfor: 'dataNewsInfor',
        //     })
        // },
        props: {
            data4: Object,
//            activeNum:String,
        },

        methods:{
            changeWidthList(val){
              let that = this;
              // alert(111)
              let computedAllWidth=0;
              let numbersAll = that.data4.specification.split('*');
              that.dataNews.forEach((item,index)=>{
                computedAllWidth+= Number(item.prodWidth);
              })
              let computedLength = Number(that.data4.processingWeight)*1000000/Number(numbersAll[0])/Number(numbersAll[1])/Number(that.data4.density);
              for(let i =0;i<that.dataNews.length;i++){
                if(that.dataNews[i].prodHeight == 'C'){
                  that.dataNews[i].prodNumber = 1;
                  that.dataNews[i].prodOneWeight= Math.floor(Number(numbersAll[0])*Number(that.dataNews[i].prodWidth)*computedLength*Number(that.data4.density)/1000000)
                }
                // if(that.dataNews[i].prodWidth)
                if(that.dataNews[i].prodHeight != 'C' && that.dataNews[i].prodHeight != ''){
                  that.dataNews[i].prodNumber = Math.floor(computedLength/Number(that.dataNews[i].prodHeight));
                  that.dataNews[i].prodOneWeight= Math.floor(that.dataNews[i].prodNumber*Number(numbersAll[0])*Number(that.dataNews[i].prodWidth)*Number(that.dataNews[i].prodHeight)*Number(that.data4.density)/1000000);
                }
              }
              let eslsWidth = Number(numbersAll[1]) - Number(computedAllWidth);
              if(that.changeWidth == 'last'){
                that.residueWidth = '0';
                that.handNoveWeiHuChengPinTrue= true;
                if(eslsWidth >= 204){
                  that.lastWidth = eslsWidth -4;
                  that.$Message.info({
                    content:language.kouchu4mmlosscainengjiagong,
                  duration: 3
                });
                }
                if(eslsWidth < 204){
                  that.lastWidth = eslsWidth ;
                  if(eslsWidth>=40){
                    that.$Message.info({
                      content:language.qingzaibeizhuzhongtianxieshengyudebaozhuangfangshiheyujijihua,
                      duration: 3
                    });
                  }
                  if(eslsWidth<40 && eslsWidth>=35){
                    that.$Message.info({
                      content:language.gaishengyuruowufakunbangjijangchuliweibiansi,
                      duration: 3
                    });
                  }
                  if(eslsWidth<35 && eslsWidth>=3){
                    that.$Message.info({
                      content:language.gaishengyujiangchuliweibiansiwufakunbang,
                      duration: 3
                    });
                  }
                  if(eslsWidth<3){
                    that.$Message.info({
                      content:language.shengyubixudayudengyu3,
                      duration: 3
                    });
                    that.handNoveWeiHuChengPinTrue= false;
                  }
                }
              }
              if(that.changeWidth== 'residue'){
                that.lastWidth = '0';
                let allWidth = [];
                that.dataNews.forEach((item,index)=>{
                  if(item.prodHeight != 'C'&& item.prodWidth != undefined){
                    allWidth.push(item.prodWidth)
                  }
                })
                that.handNoveWeiHuChengPinWidth= true;
                that.handNoveWeiHuChengPinTrue= true;
                if(allWidth.length>0){
                  let newAllWidth = allWidth.sort();
                  for(var i=0;i<newAllWidth.length;i++){
                    if (newAllWidth[i]==newAllWidth[i+1]){
                      that.handNoveWeiHuChengPinWidth= false;
                      return
                    }
                  }
                }
                that.residueWidth = Number(numbersAll[1]) - Number(computedAllWidth);
                // console.log(Number(numbersAll[1]),Number(computedAllWidth))
                if(that.residueWidth >40){
                  that.$Message.info({
                    content:language.biansudayudengyu40bixuweihuchengchengpinsizehuoshengyu,
                    duration: 3
                  });
                  that.handNoveWeiHuChengPinTrue= false;
                }
                if(that.residueWidth <3){
                  that.$Message.info({
                    content:language.biansibixudayudengyu3,
                    duration: 3
                  });
                  that.handNoveWeiHuChengPinTrue= false
                }
              }
            },
//             lastWidthChange(eve){
//               let that = this;
//               alert(111)
// //              console.log(eve.target.value)
//               if(isNaN(eve.target.value)){
//                 that.$Message.info({
//                   content:'请输入数字',
//                   duration: 3
//                 });
//                 that.lastWidth = that.activeWidth
//               }else{
//                 that.activeWidth = eve.target.value;
//                 that.residueWidth = 0;
//                 if(that.dataNews.length == 0){
//                   that.$Message.info({
//                     content:'请输入加工成品信息',
//                     duration: 3
//                   });
//                   return
//                 }
//                 let numbersAll = that.data4.specification.split('*');
//                 let computedLength = Number(that.data4.processingWeight)*1000000/Number(numbersAll[0])/Number(numbersAll[1])/Number(that.data4.density);
//                 for(let i =0;i<that.dataNews.length;i++){
//                   if(that.dataNews[i].prodHeight == 'C'){
//                     that.dataNews[i].prodNumber = 1;
//                     that.dataNews[i].prodOneWeight= Math.floor(Number(numbersAll[0])*Number(that.dataNews[i].prodWidth)*computedLength*Number(that.data4.density)/1000000)
//                   }
//                   if(that.dataNews[i].prodHeight != 'C' && that.dataNews[i].prodHeight != ''){
//                     that.dataNews[i].prodNumber = Math.floor(computedLength/Number(that.dataNews[i].prodHeight));
//                     that.dataNews[i].prodOneWeight= Math.floor(that.dataNews[i].prodNumber*Number(numbersAll[0])*Number(that.dataNews[i].prodWidth)*Number(that.dataNews[i].prodHeight)*Number(that.data4.density)/1000000);
//                   }
//                 }
//                 let allWidth = [];
// //                let numbersAll = that.data4.specification.split('*');
//                 that.dataNews.forEach((item,index)=>{
//                   if(item.prodHeight != 'C'&& item.prodWidth != undefined){
//                     allWidth.push(item.prodWidth)
//                   }
//                 })
//                 that.handNoveWeiHuChengPinWidth= true;
//                 if(allWidth.length>0){
//                   let newAllWidth = allWidth.sort();
//                   for(var i=0;i<newAllWidth.length;i++){
//                     if (newAllWidth[i]==newAllWidth[i+1]){
//                       that.handNoveWeiHuChengPinWidth= false;
//                       return
//                     }
//                   }
//                 }
//                 let computedAllWidth = 0;
//                 that.dataNews.forEach((item,index)=>{
//                   computedAllWidth+= Number(item.prodWidth);
//                 })
//                 let eslsWidth = Number(numbersAll[1]) - Number(computedAllWidth);
//                 if(eslsWidth >= 204){
//                   that.handNoveWeiHuChengPinTrue =true;
//                   if(that.lastWidth != eslsWidth-4){
//                     that.$Message.info({
//                       content:language.kouchu4mmlosscainengjiagong,
//                       duration: 3
//                     });
//                     that.handNoveWeiHuChengPinTrue =false;
//                     return;
//                   }
//                 }
//                 if(eslsWidth < 204){
//                   that.handNoveWeiHuChengPinTrue =true;
//                   if(that.lastWidth != eslsWidth){
//                     that.$Message.info({
//                       content:'请输入正确的剩余',
//                       duration: 3
//                     });
//                     that.handNoveWeiHuChengPinTrue =false;
//                     return;
//                   }
//                   if(that.lastWidth < 35){
//                     that.$Message.info(language.gaishengyujiangchuliweibiansiwufakunbang)
//                     return;
//                   }
//                   if(that.lastWidth >= 35 && that.lastWidth<40){
//                     that.$Message.info(language.gaishengyuruowufakunbangjijangchuliweibiansi)
//                     return;
//                   }
//                   if(that.lastWidth >= 40){
//                     that.$Message.info(language.qingzaibeizhuzhongtianxieshengyudebaozhuangfangshiheyujijihua)
//                     return;
//                   }
// //                  console.log(222)
// //                  that.handNoveWeiHuChengPinTrue= true;
// //                  if(that.residueWidth >40){
// //                    that.$Message.info('边丝大于40')
// //                  }
// //                  if(that.residueWidth <3){
// //                    that.$Message.info('边丝小于3')
// //                    that.handNoveWeiHuChengPinTrue= false
// //                  }

//                 }
//               }
//             },
            changeValue(value,params){
              // console.log(value,params)
              this.dataNews[params.index].deliveryPlaceCode = value.value;
              this.dataNews[params.index].deliveryPlace = value.label;
              // console.log(this.dataNews)
            },
            // popdata(){
            //    this.$emit('clpop',"this.dataNews".)
            // },
            messageInfomation(){
              if(this.changeWidth == 'last'){
                this.$Message.info({
                  content:language.shengyubixudayudengyu3,
                  duration: 3
                });
              }
              if(this.changeWidth == 'residue'){
                this.$Message.info({
                  content:language.biansizai3daosishizhijian,
                  duration: 3
                });
              }
            },
            // ...mapActions({
            //     dataNewsInformation: 'dataNewsInformation',
            // }),
            //选中数据更改理论数据
            changeProdNumber(select,value){
                let dataLength = select;
                this.selectDatas = []
                dataLength.forEach((item,index)=>{
                    this.selectDatas.push(item.dataId)
                })
            },
            //手填加工删除填写信息
            removeDataFive(indexs){
                console.log(indexs.index)
              let that = this;
                that.indexlast=indexs.index
                if(that.indexlast==0){
                    that.xinzengshow=true
                }

              that.dataNews.splice(indexs.index,1);
              let numbersAll = that.data4.specification.split('*');
              if(that.dataNews[0].prodHeight != 'C'&&that.dataNews[0].prodWidth==Number(numbersAll[1])&&  that.dataNews.length == 1){
                
                that.xinzengshow=false;
                that.shoutiandis=false;
                that.handNoveWeiHuChengPinTrue=true;
                return;
              }
              // console.log(that.dataNews(indedxs))
              let computedAllWidth = 0;
              that.dataNews.forEach((item,index)=>{
                computedAllWidth+= Number(item.prodWidth);
              })
              let eslsWidth = Number(numbersAll[1]) - Number(computedAllWidth);
              
              if(that.changeWidth == 'last'){
                that.residueWidth = '0';
                that.handNoveWeiHuChengPinTrue= true;
                if(eslsWidth >= 204){
                  that.lastWidth = eslsWidth -4;
                  that.$Message.info({
                    content:language.kouchu4mmlosscainengjiagong,
                  duration: 3
                });
                }
                if(eslsWidth < 204){
                  that.lastWidth = eslsWidth ;
                  if(eslsWidth>=40){
                    that.$Message.info({
                      content:language.qingzaibeizhuzhongtianxieshengyudebaozhuangfangshiheyujijihua,
                      duration: 3
                    });
                  }
                  if(eslsWidth<40 && eslsWidth>=35){
                    that.$Message.info({
                      content:language.gaishengyuruowufakunbangjijangchuliweibiansi,
                      duration: 3
                    });
                  }
                  if(eslsWidth<35 && eslsWidth>=3){
                    that.$Message.info({
                      content:language.gaishengyujiangchuliweibiansiwufakunbang,
                      duration: 3
                    });
                  }
                  if(eslsWidth<3){
                    that.$Message.info({
                      content:language.shengyubixudayudengyu3,
                      duration: 3
                    });
                    that.handNoveWeiHuChengPinTrue= false;
                  }
                }
              }
              if(that.changeWidth== 'residue'){
                that.lastWidth = '0';
                let allWidth = [];
                that.dataNews.forEach((item,index)=>{
                  if(item.prodHeight != 'C'&& item.prodWidth != undefined){
                    allWidth.push(item.prodWidth)
                  }
                })
                that.handNoveWeiHuChengPinWidth= true;
                that.handNoveWeiHuChengPinTrue= true;
                if(allWidth.length>0){
                  let newAllWidth = allWidth.sort();
                  for(var i=0;i<newAllWidth.length;i++){
                    if (newAllWidth[i]==newAllWidth[i+1]){
                      that.handNoveWeiHuChengPinWidth= false;
                      return
                    }
                  }
                }
                that.residueWidth = Number(numbersAll[1]) - Number(computedAllWidth);
                if(that.residueWidth >40){
                  that.$Message.info({
                    content:language.biansibixuxiaoyu40,
                    duration: 3
                  });
                  that.handNoveWeiHuChengPinTrue= false;
                }
                if(that.residueWidth <3){
                  that.$Message.info({
                    content:language.biansibixudayudengyu3,
                    duration: 3
                  });
                  that.handNoveWeiHuChengPinTrue= false
                }
              }
            },
            //手填加工填写宽度
            addWidthDataFive(indexs,a){
                // alert(111)
              let that = this;
              that.dataNews[indexs.index].prodWidth = Number(a);
              if(that.dataNews[indexs.index].prodHeight == ''){
                  that.$Message.info(language.changduweikong);
                  that.styleA.display=false
                  return
              }
              // console.log(that.data4)
              
              // console.log(that.dataNews[indexs.index].length)
              // console.log(Number(a))
              // console.log(that.data4.width)
              // console.log(that.dataNews[indexs.index].prodWidth)
              // console.log(that.dataNews[indexs.index].prodHeight)
              let numbersAll = that.data4.specification.split('*');
              let computedLength = Number(that.data4.processingWeight)*1000000/Number(numbersAll[0])/Number(numbersAll[1])/Number(that.data4.density);
              // if(a==that.data4.rawWidth){
              //       console.log(11111)
              //       console.log(that.data4.ifDengFen)
              //       that.data4.ifDengFen=true
              // }
              // that.$set(that.data4[indexs.index],"_disabled",b);
              // console.log(b)
              // console.log(a)
              // console.log(that.data4.rawWidth)
              // console.log(indexs)
              // console.log(that.data4.processingWeight,numbersAll,that.data4.density,indexs)
              // console.log(Number(numbersAll[1]))
              if(that.dataNews[indexs.index].prodHeight != 'C'&&that.dataNews[indexs.index].prodWidth==Number(numbersAll[1])&&  that.dataNews.length == 1){
                // alert(222)
                that.xinzengshow=false;
                that.shoutiandis=false;
                that.handNoveWeiHuChengPinTrue=true;
                that.dataNews[indexs.index].prodNumber = Math.floor(computedLength/Number(that.dataNews[indexs.index].prodHeight));
                that.dataNews[indexs.index].prodOneWeight =  Number(that.data4.processingWeight);
                // console.log(that.data4)

                // if(that.dataNews)
                // that.dataId = 1
                // that.dataNews.push('')
                return
              }else{
                that.xinzengshow=true;
                that.shoutiandis=true;
              if(a != '' && that.dataNews[indexs.index].prodHeight == 'C'){
                  that.dataNews[indexs.index].prodNumber = 1;
                  that.dataNews[indexs.index].prodOneWeight= Math.floor(Number(numbersAll[0])*Number(a)*computedLength*Number(that.data4.density)/1000000)
                  // that.residueWidth = parseInt(numbersAll[1]) - parseInt(a);
              }
              if(a != '' && that.dataNews[indexs.index].prodHeight != 'C' && that.dataNews[indexs.index].prodHeight != ''){
                  that.dataNews[indexs.index].prodNumber = Math.floor(computedLength/Number(that.dataNews[indexs.index].prodHeight));
                  // that.dataNews[indexs.index].prodNumber = 1;
                  that.dataNews[indexs.index].prodOneWeight= Math.floor(that.dataNews[indexs.index].prodNumber*Number(numbersAll[0])*Number(a)*Number(that.dataNews[indexs.index].prodHeight)*Number(that.data4.density)/1000000);
                  // that.residueWidth = parseInt(numbersAll[1]) - parseInt(a);
              }
              let computedAllWidth = 0;
              that.dataNews.forEach((item,index)=>{
                computedAllWidth+= Number(item.prodWidth);
              })
              let eslsWidth = Number(numbersAll[1]) - Number(computedAllWidth);
              if(that.changeWidth == 'last'){
                that.residueWidth = '0';
                that.handNoveWeiHuChengPinTrue= true;
                if(eslsWidth >= 204){
                  that.lastWidth = eslsWidth -4;
                  that.$Message.info({
                    content:language.yikouchu4mmloss,
                  duration: 3
                });
                }
                if(eslsWidth < 204){
                  that.lastWidth = eslsWidth ;
                  if(eslsWidth>=40){
                    that.$Message.info({
                      content:language.qingzaibeizhuzhongtianxieshengyudebaozhuangfangshiheyujijihua,
                      duration: 3
                    });
                  }
                  if(eslsWidth<40 && eslsWidth>=35){
                    that.$Message.info({
                      content:language.gaishengyuruowufakunbangjijangchuliweibiansi,
                      duration: 3
                    });
                  }
                  if(eslsWidth<35 && eslsWidth>=3){
                    that.$Message.info({
                      content:language.gaishengyujiangchuliweibiansiwufakunbang,
                      duration: 3
                    });
                  }
                  if(eslsWidth<3){
                    that.$Message.info({
                      content:language.shengyubixudayudengyu3,
                      duration: 3
                    });
                    that.handNoveWeiHuChengPinTrue= false;
                  }
                }
              }
              if(that.changeWidth== 'residue'){
                that.lastWidth = '0';
                let allWidth = [];
                that.dataNews.forEach((item,index)=>{
                  if(item.prodHeight != 'C'&& item.prodWidth != undefined){
                    allWidth.push(item.prodWidth)
                  }
                })
                that.handNoveWeiHuChengPinWidth= true;
                that.handNoveWeiHuChengPinTrue= true;
                if(allWidth.length>0){
                  let newAllWidth = allWidth.sort();
                  for(var i=0;i<newAllWidth.length;i++){
                    if (newAllWidth[i]==newAllWidth[i+1]){
                      that.handNoveWeiHuChengPinWidth= false;
                      return
                    }
                  }
                }
                that.residueWidth = Number(numbersAll[1]) - Number(computedAllWidth);
                if(that.residueWidth >40){
                  that.$Message.info({
                    content:language.biansibixuxiaoyu40,
                    duration: 3
                  });
                  that.handNoveWeiHuChengPinTrue= false;
                }
                if(that.residueWidth <3){
                  that.$Message.info({
                    content:language.biansibixudayudengyu3,
                    duration: 3
                  });
                  that.handNoveWeiHuChengPinTrue= false
                }
              }
          }
            },
            //修改加工重量
            addWidthDataFiveNew(){
              let that = this;
              let numbersAll = that.data4.specification.split('*');
              if(that.data4.changeWidth != undefined && that.data4.changeWidth!= null && that.data4.changeWidth !=''){
                that.changeWidth = that.data4.changeWidth;
              }
              if(that.dataNews[0].prodHeight != 'C'&&that.dataNews[0].prodWidth==Number(numbersAll[1])&&  that.dataNews.length == 1){
                that.xinzengshow=false;
                that.shoutiandis=false;
                that.handNoveWeiHuChengPinTrue=true;
                return;
              }
              let computedLength = Number(that.data4.processingWeight)*1000000/Number(numbersAll[0])/Number(numbersAll[1])/Number(that.data4.density);
//              for(let i =0;i<that.dataNews.length;i++){
//                if(that.dataNews[i].prodHeight == 'C'){
//                  that.dataNews[i].prodNumber = 1;
//                  that.dataNews[i].prodOneWeight= Math.floor(Number(numbersAll[0])*Number(that.dataNews[i].prodWidth)*computedLength*Number(that.data4.density)/1000000)
//                }
//                if(that.dataNews[i].prodHeight != 'C' && that.dataNews[i].prodHeight != ''){
//                  that.dataNews[i].prodNumber = Math.floor(computedLength/Number(that.dataNews[i].prodHeight));
//                  that.dataNews[i].prodOneWeight= Math.floor(that.dataNews[i].prodNumber*Number(numbersAll[0])*Number(that.dataNews[i].prodWidth)*Number(that.dataNews[i].prodHeight)*Number(that.data4.density)/1000000);
//                }
//              }
              let computedAllWidth = 0;
              that.dataNews.forEach((item,index)=>{
                computedAllWidth+= Number(item.prodWidth);
              })
              let eslsWidth = Number(numbersAll[1]) - Number(computedAllWidth);
              if(that.changeWidth == 'last'){
                that.residueWidth = '0';
                that.handNoveWeiHuChengPinTrue= true;
                if(eslsWidth >= 204){
                  that.lastWidth = eslsWidth -4;
                  that.$Message.info({
                    content:language.kouchu4mmlosscainengjiagong,
                  duration: 3
                });
                }
                if(eslsWidth < 204){
                  that.lastWidth = eslsWidth ;
                  if(eslsWidth>=40){
                    that.$Message.info({
                      content:language.qingzaibeizhuzhongtianxieshengyudebaozhuangfangshiheyujijihua,
                      duration: 3
                    });
                  }
                  if(eslsWidth<40 && eslsWidth>=35){
                    that.$Message.info({
                      content:language.gaishengyuruowufakunbangjijangchuliweibiansi,
                      duration: 3
                    });
                  }
                  if(eslsWidth<35 && eslsWidth>=3){
                    that.$Message.info({
                      content:language.gaishengyujiangchuliweibiansiwufakunbang,
                      duration: 3
                    });
                  }
                  if(eslsWidth<3){
                    that.$Message.info({
                      content:language.shengyubixudayudengyu3,
                      duration: 3
                    });
                    that.handNoveWeiHuChengPinTrue= false;
                  }
                }
              }
              if(that.changeWidth== 'residue'){
                that.lastWidth = '0';
                let allWidth = [];
                that.dataNews.forEach((item,index)=>{
                  if(item.prodHeight != 'C'&& item.prodWidth != undefined){
                    allWidth.push(item.prodWidth)
                  }
                })
                that.handNoveWeiHuChengPinWidth= true;
                that.handNoveWeiHuChengPinTrue= true;
                if(allWidth.length>0){
                  let newAllWidth = allWidth.sort();
                  for(var i=0;i<newAllWidth.length;i++){
                    if (newAllWidth[i]==newAllWidth[i+1]){
                      that.handNoveWeiHuChengPinWidth= false;
                      return
                    }
                  }
                }
                that.residueWidth = Number(numbersAll[1]) - Number(computedAllWidth);
                if(that.residueWidth >40){
                  that.$Message.info({
                    content:language.biansibixuxiaoyu40,
                    duration: 3
                  });
                  that.handNoveWeiHuChengPinTrue= false;
                }
                if(that.residueWidth <3){
                  that.$Message.info({
                    content:language.biansibixudayudengyu3,
                    duration: 3
                  });
                  that.handNoveWeiHuChengPinTrue= false
                }
              }
            },
            //手填订单新增填写信息
            handMoveWeiHuChengPinAdd(){
                this.dataId += 1;
                this.dataNews.push({_disabled:true,deliveryPlaceCode:this.activeDeliveryPlace.value,prodWidth:0,deliveryPlace:this.activeDeliveryPlace.label,prodHeight:'C',dataId:this.dataId,prodOneWeight:'',prodNumber:''})
                console.log(this.dataNews.length)
            },
            //手填加工填写长度
            addHeightDataFive(indexs,a){
                let that = this;
                let numbersAll = that.data4.specification.split('*');
                let computedLength = Number(that.data4.processingWeight)*1000000/Number(numbersAll[0])/Number(numbersAll[1])/Number(that.data4.density);
                if(a != 'C'&&that.dataNews[indexs.index].prodWidth==that.data4.width &&  that.dataNews.length == 1){
                // alert(44)
                that.dataNews[indexs.index]._disabled = false;
                that.xinzengshow=false;
                that.shoutiandis=false;
                that.handNoveWeiHuChengPinTrue= true;
                that.dataNews[indexs.index].prodHeight = Number(a);
                that.dataNews[indexs.index].prodNumber = Math.floor(computedLength/Number(that.dataNews[indexs.index].prodHeight));
                that.dataNews[indexs.index].prodOneWeight= Number(that.data4.processingWeight);
                // that.dataNews[indexs.index].prodOneWeight= Math.floor(Number(that.dataNews[indexs.index].prodNumber)*Number(numbersAll[0])*Number(a)*Number(that.dataNews[indexs.index].prodWidth)*Number(that.data4.density)/1000000);
                return
              }else {
                that.xinzengshow=true
                that.shoutiandis=true;
                // if(a=='C'){
                //     that.dataNews[indexs.index].prodHeight = 'C';
                // }
                if(a!='C'){
                    that.dataNews[indexs.index]._disabled = false;
                    that.dataNews[indexs.index].prodHeight = Number(a);
                }
                if(a == 'C'){
                    that.dataNews[indexs.index].prodHeight ='C';
                    that.dataNews[indexs.index]._disabled = true;
                    // that.$set(that.dataNews[indexs.index],"_disabled",true);

                }
                if(that.dataNews[indexs.index].prodWidth == '' || that.dataNews[indexs.index].prodWidth == undefined){
                    return
                }
                if(a == 'C' && that.dataNews[indexs.index].prodWidth != '' && that.dataNews[indexs.index].prodWidth != undefined){
                    that.dataNews[indexs.index].prodNumber = 1;
                    that.dataNews[indexs.index].prodHeight = 'C';
                    that.dataNews[indexs.index].prodOneWeight= Math.floor(Number(numbersAll[0])*Number(that.dataNews[indexs.index].prodWidth)*computedLength*Number(that.data4.density)/1000000)
                }
                if(a != 'C'  && that.dataNews[indexs.index].prodWidth != '' && that.dataNews[indexs.index].prodWidth != undefined){
                    that.dataNews[indexs.index].prodHeight = Number(a);
                    that.dataNews[indexs.index].prodNumber = Math.floor(computedLength/Number(that.dataNews[indexs.index].prodHeight));
                    that.dataNews[indexs.index].prodOneWeight= Math.floor(Number(that.dataNews[indexs.index].prodNumber)*Number(numbersAll[0])*Number(a)*Number(that.dataNews[indexs.index].prodWidth)*Number(that.data4.density)/1000000);
                    // that.dataNews[indexs.index].prodOneWeight= Math.floor(Number(numbersAll[0])*Number(a)*Number(that.dataNews[indexs.index].prodHeight)*Number(that.data4.density)/1000000);
                }
                let computedAllWidth = 0;
                that.dataNews.forEach((item,index)=>{
                    computedAllWidth+= Number(item.prodWidth);
                })
                let eslsWidth = Number(numbersAll[1]) - Number(computedAllWidth);
                if(that.changeWidth == 'last'){
                  that.residueWidth = '0';
                  that.handNoveWeiHuChengPinTrue= true;
                  if(eslsWidth >= 204){
                    that.lastWidth = eslsWidth -4;
                    that.$Message.info({
                      content:language.kouchu4mmlosscainengjiagong,
                    duration: 3
                  });
                  }
                  if(eslsWidth < 204){
                    that.lastWidth = eslsWidth ;
                    if(eslsWidth>=40){
                      that.$Message.info({
                        content:language.qingzaibeizhuzhongtianxieshengyudebaozhuangfangshiheyujijihua,
                        duration: 3
                      });
                    }
                    if(eslsWidth<40 && eslsWidth>=35){
                      that.$Message.info({
                        content:language.gaishengyuruowufakunbangjijangchuliweibiansi,
                        duration: 3
                      });
                    }
                    if(eslsWidth<35 && eslsWidth>=3){
                      that.$Message.info({
                        content:language.gaishengyujiangchuliweibiansiwufakunbang,
                        duration: 3
                      });
                    }
                    if(eslsWidth<3){
                      that.$Message.info({
                        content:language.shengyubixudayudengyu3,
                        duration: 3
                      });
                      that.handNoveWeiHuChengPinTrue= false;
                    }
                  }
                }
                if(that.changeWidth== 'residue'){
                that.lastWidth = '0';
                let allWidth = [];
                that.dataNews.forEach((item,index)=>{
                  if(item.prodHeight != 'C'&& item.prodWidth != undefined){
                    allWidth.push(item.prodWidth)
                  }
                })
                that.handNoveWeiHuChengPinWidth= true;
                that.handNoveWeiHuChengPinTrue= true;
                if(allWidth.length>0){
                  let newAllWidth = allWidth.sort();
                  for(var i=0;i<newAllWidth.length;i++){
                    if (newAllWidth[i]==newAllWidth[i+1]){
                      that.handNoveWeiHuChengPinWidth= false;
                      return
                    }
                  }
                }
                that.residueWidth = Number(numbersAll[1]) - Number(computedAllWidth);
                if(that.residueWidth >40){
                  that.$Message.info({
                    content:language.biansibixuxiaoyu40,
                    duration: 3
                  });
                  that.handNoveWeiHuChengPinTrue= false;
                }
                if(that.residueWidth <3){
                  that.$Message.info({
                    content:language.biansibixudayudengyu3,
                    duration: 3
                  });
                  that.handNoveWeiHuChengPinTrue= false
                }
              }
                  }
            },

            //手填加工理论数量
            addNumDataFive(indexs,a){
                // if(this.dataNews[indexs.index].prodHeight != 'C'&&this.dataNews[indexs.index].prodWidth==this.data4.width){
                //     // this.dataNews[indexs.index].prodNumber =Number(a)/this.data4.
                //     console.log(333)
                //     console.log(that.dataNews[params.index].prodNumber)
                // }
                if(this.dataNews[indexs.index].prodHeight == 'C' && Number(a)  != 1){
                    this.$Message.info(language.changduweiCzhinengweiyi);
                    this.dataNews[indexs.index].prodNumber = 1;
                    return
                }
                if(this.dataNews[indexs.index].prodHeight != 'C' && Number(a)>this.dataNews[indexs.index].prodNumber){
                    // alert(this.dataNews[indexs.index].prodNumber)
                    this.$Message.info(language.lilunshuliangbunengbi+this.dataNews[indexs.index].prodNumber+language.da);
                    return
                }
                this.dataNews[indexs.index].prodNumber =Number(a)
            },

            //手填订单确定填写信息
            handMoveWeiHuChengPinTrue(){
              let that = this;
                let numbersAll = that.data4.specification.split('*');
                // console.log(that.data4.specification)
                let computedAllWidth = 0;
                that.dataNews.forEach((item,index)=>{
                    computedAllWidth+= Number(item.prodWidth);
                })
                that.ifDengFenDisabled = false;
                for(let j=0;j<that.dataNews.length;j++){
                    if(that.dataNews[j].prodWidth==that.data4.rawWidth){
                        // that.data4.ifDengFen.disabled=true
                        //  that.setAttribute(this.data4[indexs.index].ifDengFen,disabled);
                        //  that.data4.ifDengFen.disabled==true
                        // console.log(that.data4.ifDengFen)
                       that.ifDengFenDisabled = true;
                    }
                    // console.log(that.dataNews[j].prodWidth)
                    // console.log(that.data4)
                }
                // console.log(that.dataNews)
              let eslsWidth = Number(numbersAll[1]) - Number(computedAllWidth);
              // console.log(item)
              if(that.changeWidth == 'last'){
                that.residueWidth = 0;
                that.handNoveWeiHuChengPinTrue= true;
                if(eslsWidth >= 204){
                  that.lastWidth = eslsWidth -4;
                  that.$Message.info({
                    content:language.kouchu4mmlosscainengjiagong,
                  duration: 3
                });
                }
                if(eslsWidth < 204){
                  that.lastWidth = eslsWidth ;
                  if(eslsWidth>=40){
                    that.$Message.info({
                      content:language.qingzaibeizhuzhongtianxieshengyudebaozhuangfangshiheyujijihua,
                      duration: 3
                    });
                  }
                  if(eslsWidth<40 && eslsWidth>=35){
                    that.$Message.info({
                      content:language.gaishengyuruowufakunbangjijangchuliweibiansi,
                      duration: 3
                    });
                  }
                  if(eslsWidth<35 && eslsWidth>=3){
                    that.$Message.info({
                      content:language.gaishengyujiangchuliweibiansiwufakunbang,
                      duration: 3
                    });
                  }
                  if(eslsWidth<3){
                    that.$Message.info({
                      content:language.shengyubixudayudengyu3,
                      duration: 3
                    });
                    that.handNoveWeiHuChengPinTrue= false;
                  }
                }
              }
              if(that.changeWidth == 'residue'){
                let allWidth =[];
                let allWeight = [];
                that.dataNews.forEach((item,index)=>{
                  allWidth.push(item.prodWidth);
                  allWeight.push(item.prodOneWeight);
                })
                let weight = 0;
                allWeight.forEach((item,index)=>{
                  weight += item
                })
                let width =0;
                allWidth.forEach((item,index)=>{
                  width += item
                })
                const lastWeight = Number(that.data4.processingWeight) - weight;
                const oneWeight = lastWeight/width;
                let newWeight = 0;
                for(let i = 0; i<that.dataNews.length-1;i++){
                  newWeight +=parseInt(oneWeight*that.dataNews[i].prodWidth+that.dataNews[i].prodOneWeight);
                  that.dataNews[i].prodOneWeight = parseInt(oneWeight*that.dataNews[i].prodWidth+that.dataNews[i].prodOneWeight);
                }
                that.dataNews[that.dataNews.length-1].prodOneWeight = Number(that.data4.processingWeight) -newWeight
              }
              // console.log(changeWidth)
              that.$emit('on-change',{'dataNews':that.dataNews,'residueWidth':that.residueWidth,'lastWidth':that.lastWidth,'changeWidth':that.changeWidth,'shengYuArea':that.shengYuArea,'ifDengFenDisabled':that.ifDengFenDisabled})
            },

            // 交货地
            jiaohuodi(){
              let that = this;
              that.language=language
              // console.log(that.data4)
              axios.post(config.placeofDelivery,{}).then(function(response){
                if(response.data.resultCode  == 1){
                  let activeValues = response.data.resultData;
                  let arrNews= [];
                  for(let i =0 ;i <activeValues.length ;i++){
                    let activeName = {
                      // value:activeValues[i].siteCode,
                      value:activeValues[i].tradeAddress,
                      label:activeValues[i].tradeAddress
                    }
                    arrNews.push(activeName)
                  }
                  if(arrNews.length != undefined && arrNews.length != null &&arrNews.length>0){
                    that.shengYuArea = arrNews[0].value
                    that.activeDeliveryPlace = arrNews[0];
                    that.placeofDelivery = arrNews;
                  }
                  // console.log(arrNews)
                  if(that.data4.dataNews != undefined && that.data4.dataNews.length>0){
                    that.dataNews = [].concat(JSON.parse(JSON.stringify(that.data4.dataNews)));
                    that.addWidthDataFiveNew()
                  }else{
                    that.dataNews[0]._disabled = true;
                    that.dataNews[0].deliveryPlace = arrNews[0].label;
                    that.dataNews[0].deliveryPlaceCode = arrNews[0].value;
                  }
                  if(that.data4.lastWidth != undefined){
                    that.lastWidth = that.data4.lastWidth;
                  }
                  if(that.data4.residueWidth != undefined){
                    that.residueWidth =  that.data4.residueWidth;
                  }
                  if(that.data4.shengYuArea != undefined){
                    that.shengYuArea =  that.data4.shengYuArea;
                  }
                  if(that.data4.changeWidth != undefined && that.data4.changeWidth!= null && that.data4.changeWidth !=''){
                    that.changeWidth = that.data4.changeWidth;
                  }
                  if(that.data4.processingWeight != undefined && that.dataNews.length == 1 && that.dataNews[0].prodOneWeight==''){
                    that.dataNews[0].prodOneWeight = that.data4.processingWeight;
                  }
                    console.log(that.dataNews)
                }
              })
              if(that.data4.residueWidth != undefined){
                  that.residueWidth =  that.data4.residueWidth;
              }
//                axios.post(config.placeofDelivery,{}).then(function(response){
//                    if(response.data.resultCode  == 1){
//                        let activeValues = response.data.resultData;
//                        let arrNews= [];
//                        for(let i =0 ;i <activeValues.length ;i++){
//                            let activeName = {
//                                value:activeValues[i].siteCode,
//                                label:activeValues[i].tradeAddress
//                                // tradeAddress:activeValues[i].tradeAddress,
//                            }
//                            arrNews.push(activeName)
//                        }
//                        that.dataNews[0].deliveryPlace = arrNews[0].label,
//                        that.dataNews[0].deliveryPlaceCode = arrNews[0].value,
//                        that.activeDeliveryPlace = arrNews[0],
//                        that.placeofDelivery = arrNews;
//                    }
//                })
            },
             //同上交货地
            againDeliveryDate(indexs){
              console.log(indexs)
              let that = this;
              const deliveryPlaceCode = that.dataNews[indexs.index-1].deliveryPlaceCode;
              that.dataNews[indexs.index].deliveryPlaceCode=deliveryPlaceCode;
              console.log(deliveryPlaceCode);
            },
        },
        mounted(){
//            console.log(this)
            this.jiaohuodi();
        }

    };
</script>



// WEBPACK FOOTER //
// addDingDanComplate.vue?4f595656